import {IApiActionResult} from "./models/ApiActionResult";
import {SEND_MESSAGE_API_ROUTE, SEND_FILE_MESSAGE_API_ROUTE, SEND_PREVIEW_MESSAGE_API_ROUTE, GET_INIT_MESSAGE_API_ROUTE, GET_PREV_CHAT_MESSAGES_MESSAGE_API_ROUTE } from "./apiRoutes";
import { IInitMessages, IMessage } from "../~store/models/messages/Message";
import { METHODS } from "http";
import { FileType } from "src/app/shared/components/choose-file-dialog/ChooseFileDialog";
import { read } from "fs";
import { getApiActionResult, fetchGet } from "src/~api/ApiHelper";
import { IChannelMessage } from "../~store/models/ChannelMessage";
import { ACCOUNT_HEADER, CHANNEL_TOKEN_HEADER, EXTERNAL_ID_HEADER, MESSAGE_TYPE_HEADER, PARENT_HEADER } from "../~store/actions/constants";
import { getExternalId, getParentHeader, getUrlParam } from "src/app/shared/helpers/url-helper/UrlParamsHelper";
import { IMessagePreview } from "../~store/models/MessagePreview";
import { START_MESSAGE_HEADER } from "../~store/models/Constants";

export const sendMessageAsync = async (message: IChannelMessage, isStartMessage: boolean): Promise<IApiActionResult<void>> => {
    const headers = getHeaders();
    if(!headers) {
        return new Promise<IApiActionResult<void>>(() => false )
    }
    headers.set('Content-Type', 'application/json');
    headers.set(ACCOUNT_HEADER, getUrlParam(ACCOUNT_HEADER));
    headers.set(PARENT_HEADER, getParentHeader());

    if(isStartMessage) {
        headers.set(MESSAGE_TYPE_HEADER, START_MESSAGE_HEADER);
    }

    const fetchPromise = fetch(
        
        SEND_MESSAGE_API_ROUTE(),
        {
            body: JSON.stringify(message),
            method: 'POST',
            headers
        },
        
    );
    return await getApiActionResult(fetchPromise);
};

export const sendPreviewUserMessageAsync = async (message: IMessagePreview): Promise<IApiActionResult<void>> => {
    const headers = getHeaders();
    if(!headers) {
        return new Promise<IApiActionResult<void>>(() => false )
    }
    headers.set('Content-Type', 'application/json');

    const fetchPromise = fetch(
        
        SEND_PREVIEW_MESSAGE_API_ROUTE(),
        {
            body: JSON.stringify(message),
            method: 'POST',
            headers
        },
        
    );
    return await getApiActionResult(fetchPromise);
};

export const sendFileMessageAsync = async (file: File, type: FileType) : Promise<IApiActionResult<IMessage>> =>  {
    const headers = getHeaders();
    if(!headers) {
        return new Promise<IApiActionResult<IMessage>>(() => false )
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", type.toString());

    const fetchPromise = fetch(SEND_FILE_MESSAGE_API_ROUTE(), 
        {
            method: 'POST',
            headers,
            body: formData
        }
    );
    return await getApiActionResult(fetchPromise, true);
};

export const getInitMessagesAsync = async () : Promise<IApiActionResult<IInitMessages>> => {
    const headers = getHeaders();
    if(!headers) {
        return new Promise<IApiActionResult<IInitMessages>>(() => false )
    }

    const fetchPromise = fetch(GET_INIT_MESSAGE_API_ROUTE(), 
        {
            method: 'GET',
            headers
        }
    );
    return await getApiActionResult(fetchPromise, true);
}

export const getPrevChatAsync = async (currentChatId: number) : Promise<IApiActionResult<IMessage[]>> => {
    const headers = getHeaders();
    if(!headers) {
        return new Promise<IApiActionResult<IMessage[]>>(() => false )
    }

    const fetchPromise = fetch(GET_PREV_CHAT_MESSAGES_MESSAGE_API_ROUTE(currentChatId), 
        {
            method: 'GET',
            headers
        }
    );
    return await getApiActionResult(fetchPromise, true);
}

const getHeaders = (): Headers|null => {
    const headers: Headers = new Headers();

    const token = getUrlParam(CHANNEL_TOKEN_HEADER);
    const externalId = getExternalId();

    if(!token || !externalId) {
        return null;
    }

    headers.set(CHANNEL_TOKEN_HEADER, token);
    headers.set(EXTERNAL_ID_HEADER, externalId);

    return headers;
}
